import React from 'react';
import i18next from 'i18next';
import { connect } from 'react-redux';
import classNames from 'classnames';
import InputTextIcon from '../../InputTextIcon/InputTextIcon';
import { setSearchFilter } from '../../../actions/eventsActions';
import rulesIcon from 'icons/search.svg';
import closeIcon from 'icons/close.svg';

class EventsSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
    };
  }

  onFocus = () => {
    this.setState({ active: true });
  };

  onBlur = () => {
    this.setState({ active: false });
  };

  onChange = (e) => {
    this.props.setSearchFilter(e.target.value);
  };

  clearSearch = () => {
    this.props.setSearchFilter('');
  };

  render() {
    const { active } = this.state;
    const { search } = this.props;

    return (
      <div className={classNames('events-search', { active })}>
        <InputTextIcon
          name="event"
          placeholder={i18next.t('search.placeholder')}
          className="events-search__input"
          position="right"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onChange={this.onChange}
          value={search}
          glyph={!search ? rulesIcon : closeIcon}
          iconProps={{
            onClick: search ? this.clearSearch : null,
          }}
        />
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      search: state.events.filters.search || '',
    };
  },
  {
    setSearchFilter,
  }
)(EventsSearch);



// WEBPACK FOOTER //
// ./app/components/EsportsGame/EventsSearch/EventsSearch.jsx